import { render, staticRenderFns } from "./BoschDoor.vue?vue&type=template&id=2b6dbb78&scoped=true"
import script from "./BoschDoor.vue?vue&type=script&lang=js"
export * from "./BoschDoor.vue?vue&type=script&lang=js"
import style0 from "./BoschDoor.vue?vue&type=style&index=0&id=2b6dbb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6dbb78",
  null
  
)

export default component.exports